import _ from 'lodash';

export const DEMO_REPORT_HANDLERS_BY_METRIC_SET = {
  summaryreport: 'fetchSummaryReport',
  agentsreport: 'fetchAgentsReport',
  topicsreport: 'fetchTopicsReport',
  topichierarchyreport: 'fetchTopicsReport',
  ivrexecutivesummaryreport: 'fetchIvrSummaryReport',
  ivrendstatesreport: 'fetchIvrEndStatesReport',
};

export function getDemoReportHandler(metricSet) {
  const key = _.toLower(metricSet);
  return _.has(DEMO_REPORT_HANDLERS_BY_METRIC_SET, key) ? DEMO_REPORT_HANDLERS_BY_METRIC_SET[key] : undefined;
}
